import { createContext, useContext } from 'react';

import useStickyState from './useStickyState';

export type Role = 'Mentee' | 'Mentor' | 'Admin' | "ApplicantMentee";

export interface AuthorizationData {
	permissions: string[]
	role: Role | null
}

export const AuthorizationDataContext = createContext(null);

const initialData: AuthorizationData = {
	permissions: [],
	role: null
};

const AuthorizationDataProvider = (props: any) => {
	const [ data, setData ] = useStickyState(initialData, 'authorizationData'); // user permissions and role

	const deleteData = () => {
		setData(initialData)
	};

	const isAuthorized = (permissions: string[] = []): boolean => {
		return permissions.every(permission => data.permissions.includes(permission));
	}

	return <AuthorizationDataContext.Provider value={{ ...data, deleteData, isAuthorized, setData }} {...props} />;
};

export const useAuthorizationDataContext = (): any => useContext(AuthorizationDataContext);

export default AuthorizationDataProvider;